import React from "react";
import { Redirect } from "react-router-dom";
import { validateRouteAccess } from "../../utils/routeAccessControl";
import logger from "../../utils/logger";


/**
 * RoleBasedRoute component that enforces access control based on user roles
 * Redirects unauthorized users to appropriate pages
 */
const RoleBasedRoute = ({ children, path, component: Component, allowUnauthenticated = false, ...rest }) => {
  // If route allows unauthenticated access, render children
  if (allowUnauthenticated) {
    if (Component) {
      return <Component {...rest} />;
    }
    return children;
  }

  // Validate route access
  const validation = validateRouteAccess(path);

  if (!validation.hasAccess) {
    // Log unauthorized access attempt
    logger.warn(`Access denied: ${validation.reason} for route ${path}`);

    // Redirect to appropriate route
    return <Redirect to={validation.redirectTo} />;
  }

  if (Component) {
    return <Component {...rest} />;
  }

  return children;
};

export default RoleBasedRoute;
